export const KEY_GET_DOWNLOAD_EMPLOYEES_IMPORTS_TEMPLATE = 'get.employees-imports-template.call';
export const KEY_POST_EMPLOYEES_IMPORTS_TEMPLATE = 'post.employees-imports-template.call';
export const KEY_GET_EMPLOYEES_IMPORTS_BY_JOB_ID = 'get.employees-imports-by-job-id.call';
export const KEY_GET_EMPLOYEES_IMPORTS_OVERVIEW = 'get.employees-imports-overview.call';
export const KEY_GET_EMPLOYEES_IMPORTS_STATS = 'get.employees-imports-stats.call';
export const KEY_GET_EMPLOYEES_IMPORT = 'get.employees-import.call';
export const KEY_PUT_EMPLOYEES_IMPORT = 'put.employees-import.call';

export const KEY_GET_EMPLOYEES_STATS = 'get.employees-stats.call';
export const KEY_GET_EMPLOYEES = 'get.employees.call';
export const KEY_GET_UNASSIGNED_EMPLOYEES = 'get.unassigned-employees.call';
export const KEY_GET_EMPLOYER_BY_ID = 'get.employer-by-id.call';
export const KEY_PUT_EMPLOYER_BY_ID = 'put.employer-by-id.call';
export const KEY_DELETE_EMPLOYER_BY_ID = 'delete.employer-by-id.call';
export const KEY_POST_EMPLOYEES_IMPORTS_CONFIRM = 'post.employees-imports-confirm.call';
export const KEY_POST_EMPLOYEES_IMPORTS_ABORT = 'post.employees-imports-abort.call';
export const KEY_GET_EMPLOYEES_FILTERS = 'get.employees-filters.call';

export const KEY_POST_EMPLOYER_BY_ID_ENABLE = 'post.employer-by-id-enable.call';
export const KEY_POST_EMPLOYER_BY_ID_DISABLE = 'post.employer-by-id-disable.call';

export const KEY_POST_EMPLOYEES_IMPORTS_ABORT_BY_JOB_ID =
  'post.employees-imports-abort-by-job-id.call';

export const KEY_POST_EMPLOYEES_DELETE_CHECK = 'post.employees-delete-check.call';

export const KEY_POST_EMPLOYEE = 'post.employee.call';

export const KEY_POST_EMAIL_ALREADY_EXIST = 'post.email-already-exist.call';
